/* eslint-disable max-len */
<template>
  <sui-modal v-model="modalOpen">
    <sui-modal-header>Class culture explanation</sui-modal-header>
    <sui-modal-content class="scrolling">
      <table class="ui striped selectable table">
        <thead>
          <th>Ratio (L:R)</th>
          <th>Indicates</th>
          <th></th>
        </thead>
        <tbody>
          <tr class="positive">
            <td>7:1/8:1 or above</td>
            <td>“Healthy” Class Culture</td>
            <td>
              Most students find it a psychologically safe, friendly and
              comfortable place
            </td>
          </tr>
          <tr class="warning">
            <td>Between 1:1 and 7:1</td>
            <td>“Not a healthy” Class Culture</td>
            <td>
              Some work needed for all students to find it a psychologically
              safe, friendly and comfortable place to be
            </td>
          </tr>
          <tr class="negative">
            <td>Any ration where “Rejects” exceed “Likes”</td>
            <td>Unhealthy Class Culture</td>
            <td>
              Significant work needed for all students to find it a
              psychologically safe, friendly and comfortable place to be.
            </td>
          </tr>
        </tbody>
      </table>
      <ul>
        <li>
          Even if the class culture is not considered healthy, no unchosen
          students still is still a positive outcome.
        </li>
      </ul>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button positive v-on:click="hideDetailsModal"> Ok </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TestClassCultureLegend',
  components: {},
  computed: {
    ...mapGetters({
      classCultureLegendOpen: 'classCultureLegendOpen',
    }),
    modalOpen: {
      get() {
        return this.classCultureLegendOpen;
      },
      set(isOpen) {
        this.hideDetailsModal();
        return isOpen;
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    hideDetailsModal() {
      this.$store.dispatch('hideClassCultureLegend');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestClassCultureLegend.vue